import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-body-2 mb-2" }, " Se borrarán tus datos personales: nombre, apellidos, correo, teléfono, fecha de nacimiento, ciudad, foto y contraseña. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-body-2 mb-2" }, " Tus resultados y partidas seguirán en los eventos y en las clasificaciones, como «Desconocido». ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-body-2 mb-4" }, " No se puede deshacer y no podrás volver a entrar con esta cuenta. ", -1)

import { computed, ref, watch } from "vue";
import axios from "axios";
import { borrarMiCuenta } from "@/services/UsuariosService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalBorrarCuenta',
  props: {
    isVisible: { type: Boolean }
  },
  emits: ["update:isVisible", "borrada"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const visible = computed({
  get: () => props.isVisible,
  set: valor => emit("update:isVisible", valor),
});

const contrasena = ref("");
const error = ref("");
const borrando = ref(false);

watch(
  () => props.isVisible,
  abierto => {
    if (!abierto) return;
    contrasena.value = "";
    error.value = "";
  }
);

const borrar = async () => {
  if (!contrasena.value || borrando.value) return;
  error.value = "";
  borrando.value = true;
  try {
    await borrarMiCuenta(contrasena.value);
    emit("borrada");
  } catch (e) {
    error.value =
      (axios.isAxiosError(e) && e.response?.data?.message) ||
      "No se ha podido borrar la cuenta. Prueba otra vez en un rato.";
  } finally {
    borrando.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    "max-width": "480"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-wrap" }, {
            default: _withCtx(() => [
              _createTextVNode("¿Borrar tu cuenta?")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2,
              _hoisted_3,
              _createVNode(_component_v_text_field, {
                modelValue: contrasena.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contrasena).value = $event)),
                label: "Tu contraseña",
                type: "password",
                autocomplete: "current-password",
                density: "comfortable",
                "hide-details": "auto",
                onKeydown: _withKeys(borrar, ["enter"])
              }, null, 8, ["modelValue"]),
              (error.value)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "error",
                    variant: "tonal",
                    density: "compact",
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(error.value), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                disabled: borrando.value,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancelar")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                color: "error",
                variant: "tonal",
                loading: borrando.value,
                disabled: !contrasena.value,
                onClick: borrar
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Borrar mi cuenta ")
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})